// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3T3wl","productName":"Table_productName__2Zvj2"};